import { Card } from "../../design-v2";

export default function UnsupportedBlockCard({ position }) {
  return (
    <Card as="article" tone="raised" className="lz-product-unsupported-card">
      {position ? <span className="lz-product-block-index">{position}</span> : null}
      <div>
        <h3>Advanced training block</h3>
        <p>
          This published block is preserved, but its advanced structure cannot be displayed in detail yet.
        </p>
      </div>
    </Card>
  );
}
